import { config } from 'lib-shared-backend-config';
/** Various application error prompts. */
export const appErrors = {
    activeOngoingCall: {
        title: 'Active ongoing call',
        description: `Login was prevented because you are active in an ongoing call.\nClose any ongoing calls in other windows to proceed.`,
        actions: [
            {
                type: 'link',
                label: 'Contact us',
                url: `https://${config.domain.web}/contact`,
            },
        ],
    },
    agentInsufficientRoles: {
        title: 'Permission denied',
        description: `Your agent does not have sufficient roles to login at ${window.location.host}`,
        actions: [
            {
                type: 'link',
                label: 'Contact us',
                url: `https://${config.domain.web}/contact`,
            },
        ],
    },
    failedOktaLogin: {
        title: 'Okta login failed',
        description: `Login to ${window.location.host} failed. Please contact your Okta admin.`,
        actions: [
            {
                type: 'link',
                label: 'Contact us',
                url: `https://${config.domain.web}/contact`,
            },
        ],
    },
    oktaHandleRedirect: {
        title: 'Redirecting to Okta',
        description: `Please standby...`,
        actions: [],
    },
    oktaHandleSigninRedirect: {
        title: 'Logging in',
        description: `Please standby...`,
        actions: [],
    },
    noInternetConnection: {
        title: 'Internet connection',
        description: `It seem you don't have an internet connection right now.`,
        actions: [
            {
                type: 'button',
                label: 'Try again',
                onClick: () => window.location.reload(),
            },
        ],
    },
    organizationSuspended: {
        title: 'Suspended',
        description: 'This organization has been suspended.',
        actions: [
            {
                type: 'link',
                label: 'Contact us',
                url: `https://${config.domain.web}/contact`,
            },
        ],
    },
    unsupportedBrowserFeatures: {
        title: 'Unsupported browser features',
        description: 'Your browser does not seem to support one or more required features. Try a different modern browser.',
        actions: [
            {
                type: 'link',
                label: 'Google Chrome',
                url: 'https://www.google.com/chrome/',
            },
            {
                type: 'link',
                label: 'Mozilla Firefox',
                url: 'https://www.mozilla.org/firefox/',
            },
            {
                type: 'link',
                label: 'Apple Safari (macOS)',
                url: 'https://www.apple.com/safari/',
            },
        ],
    },
    unsupportedPlatform: {
        title: 'Unsupported platform',
        description: 'Your device does not seem to be supported.',
    },
};
